import {View} from "react-native";
import {FontAwesome5} from "@expo/vector-icons";
import {Layout, Text} from "@ui-kitten/components";
import * as React from "react";
import {Bold} from "../../../shared/bold";
import {TransparentBox} from "../../../ui/transparent-box";

export const PickupRequestExplain = () => <Layout level='2' style={{
    backgroundColor: 'transparent',
    padding: 20
}}>
    <TransparentBox>
        <View style={{alignItems: "center"}}>
            <FontAwesome5 name="truck" size={50} color='#a0c946'/>
        </View>
        <Text
            style={{
                fontSize: 25,
                lineHeight: 25,
                marginTop: 10,
                marginBottom: 20,
                textAlign: "center",
                color: "white"
            }}>Collection Service</Text>
        <Text style={{color: 'white', lineHeight: 25, textAlign: 'center'}}><Text style={{color: '#a0c946', fontWeight: 'bold'}}>Schedule</Text> your pick up and our trucks will <Text style={{color: '#a0c946', fontWeight: 'bold'}}>collect</Text> your recyclable right <Text style={{color: '#a0c946', fontWeight: 'bold'}}>from your doorstep</Text>.</Text>
    </TransparentBox>
</Layout>;